<template>
    <a-col :span="24">
      <a-row style="padding: 12px 0px 12px 0px; text-align: left;">
        <a-button type="primary" @click="showAddProduct">添加新产品</a-button>
      </a-row>

      <a-row class="content-container">
        <a-row v-for="(product, index) in list" :key="index" class="content-item">
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: left; line-height: 32px;">
            <span><b>名称：</b>{{product.name}}</span>
          </a-col>
          <!-- a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="margin-bottom: 4px;">
            <h3>{{product.sku}}</h3>
          </a-col-->
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: left; line-height: 32px;">
            <span><b>价格：</b>{{product.price}}{{product.unit_name}}</span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: left; line-height: 32px;">
            <span><b>有效时间：</b>{{product.service_span}}</span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: left; line-height: 32px;">
            <span><b>创建时间：</b>{{product.created | timeChange}}</span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: left; line-height: 32px;">
            <span><b>更新时间：</b>{{product.updated | timeChange}}</span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" style="text-align: right; line-height: 32px;">
            <span>
              <a style="color: #1890ff; margin-right: 4px;" @click="editProduct(index)">修改</a>|
              <a style="color: #1890ff; margin-right: 4px;" @click="changeProductStatus(index)">{{product.status | statusChange}}</a>
            </span>
          </a-col>
        </a-row>
      </a-row>

      <a-row v-if="list.length > 0" style="margin-top: 12px;">
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>

      <a-modal v-model="add_product" title="添加产品" :footer="null" :width="modalWidth" @cancel="resetAddProduct">
        <edit-product @change="editChange"/>
      </a-modal>
      <a-modal v-model="edit_product" title="修改产品" :footer="null" :width="modalWidth" @cancel="resetEditProduct">
        <edit-product :id="id" @change="editChange"/>
      </a-modal>
    </a-col>
</template>

<script>
import EditProduct from './EditProduct.vue'

export default {
  name: 'Product',
  data() {
    return {
      tab: 'pro',
      postdata: {},
      list: [],
      add_product: false,
      edit_product: false,
      refresh: 0,
      page: 0, 
      modalWidth: "98%",
      id: ""
    }
  },
  components: {
    EditProduct
  },
  filters: {
    timeChange: function (value) {
      if (!value) {
        return "";
      }
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;

      let d = date.getDate();
      d = d < 10 ? "0" + d : d;

      let h = date.getHours();
      h = h < 10 ? "0" + h : h;

      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;

      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;

      return y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    statusChange: function (value) {
      if (value == 1) {
        return "禁用";
      } else {
        return "恢复";
      }
    }
  },
  methods: {
    showAddProduct: function() {
      this.add_product = !this.add_product;
    },
    resetAddProduct: function() {
      this.add_product = !this.add_product;
    },
    editProduct: function(index) {
      this.id = this.list[index].id.toString();
      this.edit_product = !this.edit_product;
    },
    resetEditProduct: function() {
      this.edit_product = !this.edit_product;
    },
    editChange: function(type) {
      this.page = 0;
      let postdata = {
        task: "GET_PRODUCT_LIST",
        from: this.page * 15,
        to: (this.page + 1) * 15
      }
      let that = this;
      that.post("product", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.list = data.data;
            if (type == "UPDATE_PRODUCT_DETAIL") {
              that.edit_product = !that.edit_product;
            }
            if (type == "ADD_PRODUCT") {
              that.add_product = !that.add_product;
            }
            that.page += 1;
          }
        }).catch(function (e) {
      });
    },
    changeProductStatus: function(index) {
      let postdata = {
        id: this.list[index].id,
        task: "CHANGE_PRODUCT_STATUS"
      }
      let that = this;
      that.post("product", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            let item = that.list[index];
            item["status"] = item["status"] == 1 ? 0:1;
            that.$set(that.list, index, item);
          } else {
            that.$message.error("修改失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("修改失败");
      });
    },
    loadMore: function() {
      let postdata = {
        task: "GET_PRODUCT_LIST",
        from: this.page * 10,
        to: (this.page + 1) * 10
      }
      let that = this;
      that.post("product", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            if (data.data.length == 0) {
              that.$message.success("没有更多数据了");
            } else {
              for(let i = 0; i < data.data.length; i++) {
                that.list.push(data.data[i]);
              }
              that.page += 1;
            }
          }
        }).catch(function (e) {
      });
    }
  },
  created() {
    let postdata = {
      task: "GET_PRODUCT_LIST",
      from: this.page * 10,
      to: (this.page + 1) * 10
    }
    let that = this;
    that.post("product", postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.list = data.data;
          that.page += 1;
        }
      }).catch(function (e) {
    });

    let deviceWidth = document.body.clientWidth
    if (deviceWidth >= 576) {
      this.modalWidth = "800px"; 
    }
  }
}
</script>

<style scoped>
  .content-container {
    border-bottom: 1px solid #e1e4e8;
    border-left: 1px solid #e1e4e8;
    border-right: 1px solid #e1e4e8;
  }
  .content-item {
    border-top: 1px solid #e1e4e8;
    padding: 8px;
  }
  .content-item:hover {
    background-color: #e6f7ff;
    cursor: pointer;
  }
</style>

